import React from 'react';
import { translate } from '../../Services/translation';
import Collapsible from '../Collapsible';
import ProductDescription from './ProductDescription';
import ProductShippingAndDelivery from './ProductShippingAndDelivery';
import ProductSpecification from './ProductSpecification';

const SpecificationTabsMobile = (props) => {
  const description = props.productSpecifications.productDescription;
  const shippingInfo = props.productSpecifications.productShippingTemplate;
  const specification = props.productSpecifications.productSpecifications;
  const isB2b = props.isB2b;
  const showProductShippingInformation = props.showProductShippingInformation;

  return (
    <div className="product-specifications--mobile product-specifications">
      <ProductDescription description={description} />
      <Collapsible
        className="text-medium collapsible-header"
        transitionDuration="0.2"
        label={translate('product-specification.specification')}
      >
        <ProductSpecification specification={specification} />
      </Collapsible>
      {shippingInfo && !isB2b && showProductShippingInformation && (
        <Collapsible
          className="text-medium collapsible-header"
          transitionDuration="0.2"
          label={translate('product-specification.shippingInfo')}
        >
          <ProductShippingAndDelivery shippingInfo={shippingInfo} />
        </Collapsible>
      )}
    </div>
  );
};

export default SpecificationTabsMobile;
